import React from "react"
import PropTypes from "prop-types"
import axios from "axios"

class LikeButton extends React.Component {
  constructor(props) {
    super(props);
    //при создании компонента ему передаеются данные типа {data: {id: 999, is_liked: false}}
    //пихаем эти данные в state. id не пихаем, потому что его состояние мы можем не изменять
    this.state = {isLiked: this.props.data.is_liked};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    // если мы внутри функции axios (библиотека) вызовем this, он будет указывать на функцию axios
    // а нам надо обратиться глобальнее к конструктору класса React
    var self = this;
    let itemId = this.props.data.id;
    // ajax запрос на лайк
  	axios({
	   method: "POST", 
	   url: "/like",
	   data: {id: itemId}
	  }) // если успешно то меняем state кнопки на предыдущий путем того что !BOOLEAN выдает противоположное состояние
    .then(function(response){
      if (response.status == 200){
        self.setState(prevState => ({
          isLiked: !prevState.isLiked
        }));
      } else {
      }
    });
    
  }

  render () {
    return (
        <a className={this.state.isLiked ?
                    'media-button btn-like liked' :
                    'media-button btn-like'} 
                    onClick={this.handleClick}>
        {this.state.isLiked ? 'Из избранного' : 'В избранное'}
        </a>
    );
  }
}

export default LikeButton

